"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VbzAnimation = void 0;
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable sonarjs/cognitive-complexity */
const react_1 = __importStar(require("react"));
const lottie_web_1 = __importDefault(require("lottie-web"));
const className_1 = require("../../utils/className");
const Modal_1 = require("../Modal");
const in_1 = __importDefault(require("./data/in"));
const in_out_1 = __importDefault(require("./data/in_out"));
const spin_1 = __importDefault(require("./data/spin"));
exports.VbzAnimation = (_a) => {
    var { id, containerIdLottie = '', typeModal = 'full', finishMode = 'yes', currentState, message, className = '', stopEndDuration = 3000, onExit } = _a, props = __rest(_a, ["id", "containerIdLottie", "typeModal", "finishMode", "currentState", "message", "className", "stopEndDuration", "onExit"]);
    const [spin, setSpin] = react_1.useState({});
    const [isOpen, setIsOpen] = react_1.useState(false);
    const [loadAnimation, setLoadAnimation] = react_1.useState(false);
    const classContainer = react_1.useMemo(() => `.key-animation-${containerIdLottie}`, [
        containerIdLottie,
    ]);
    react_1.useEffect(() => {
        if (currentState.isLoading)
            setIsOpen(true);
    }, [currentState]);
    const onOpened = react_1.useCallback(() => {
        setLoadAnimation(true);
    }, []);
    const onFinish = react_1.useCallback(() => {
        setIsOpen(false);
        setSpin({});
        setLoadAnimation(false);
    }, []);
    const startEndStep = react_1.useCallback(() => {
        const endAnimation = lottie_web_1.default.loadAnimation({
            container: document.querySelector(classContainer),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: in_out_1.default,
        });
        endAnimation.addEventListener('loopComplete', () => {
            onFinish();
            endAnimation.destroy();
        });
    }, [loadAnimation]);
    react_1.useEffect(() => {
        if (currentState.isLoading && loadAnimation) {
            const animationIn = lottie_web_1.default.loadAnimation({
                container: document.querySelector(classContainer),
                renderer: 'svg',
                loop: true,
                autoplay: true,
                animationData: in_1.default,
            });
            animationIn.addEventListener('loopComplete', () => {
                animationIn.destroy();
                setSpin(lottie_web_1.default.loadAnimation({
                    container: document.querySelector(classContainer),
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    animationData: spin_1.default,
                }));
            });
        }
    }, [loadAnimation]);
    react_1.useEffect(() => {
        if (Object.keys(spin).length)
            if (finishMode === 'wait' || finishMode === 'yes') {
                spin.addEventListener('loopComplete', () => {
                    if (!currentState.isLoading && finishMode === 'yes') {
                        spin.destroy();
                        startEndStep();
                    }
                    if (!currentState.isLoading && finishMode === 'wait') {
                        spin.pause();
                        setTimeout(() => {
                            spin.destroy();
                            startEndStep();
                        }, stopEndDuration);
                    }
                });
            }
            else if (finishMode === 'no' && !currentState.isLoading) {
                spin.destroy();
                onFinish();
            }
    }, [spin, currentState.isLoading]);
    return (react_1.default.createElement(Modal_1.VbzModal, Object.assign({ id: id, isOpen: isOpen, type: typeModal, onExit: onExit, defaultHeader: false, onOpened: onOpened, className: className_1.mapToCssModules([className, 'vbz-animation']) }, props),
        react_1.default.createElement("div", { id: id, className: className_1.mapToCssModules([
                'vbz-animation-lottie',
                `key-animation-${containerIdLottie}`,
                !currentState.isLoading && !currentState.isSuccess ? 'inverse' : '',
            ]) }),
        react_1.default.createElement("div", { className: "text start" },
            currentState.isLoading && (message === null || message === void 0 ? void 0 : message.loading.map((msg) => (react_1.default.createElement("span", { className: "start", key: msg }, msg)))),
            currentState.isSuccess &&
                !currentState.isLoading && (message === null || message === void 0 ? void 0 : message.success.map((msg) => (react_1.default.createElement("span", { className: "start", key: msg }, msg)))),
            !currentState.isSuccess &&
                !currentState.isLoading && (message === null || message === void 0 ? void 0 : message.error.map((msg) => (react_1.default.createElement("span", { className: "finish", key: msg }, msg)))))));
};
//# sourceMappingURL=index.js.map